const actionTypes = {
    setDefaultPrice: 'setDefaultPrice',
    setUpdateShipping: 'setUpdateShipping',
    addShopName: 'addShopName',
    saveShippingList: 'saveShippingList',
    setShippingCounts: 'setShippingCounts',
    saveCurrency: 'saveCurrency',
    ShowWarning: 'ShowWarning',
    ShowMessage: 'ShowMessage',
    setSaveProcessing: 'setSaveProcessing',
    setFetching: 'setFetching',
    active: 'active',
    toggleModal: 'toggleModal',
    setSrc: 'setSrc',
    setAlt: 'setAlt',
    updateTitle: 'updateTitle',
    setDeleted: 'setDeleted',
    saveShopId: 'saveShopId',
    saveStatesList: 'saveStatesList',
    saveCountries: 'saveCountries',
    saveCountry: 'saveCountry',
    payment: 'payment',
    paymentId: 'paymentId',
    setPaymentInterval: 'setPaymentInterval',
    setToast: 'setToast',
    saveFreeShippingRule: 'saveFreeShippingRule',
    setTitle: 'setTitle',
    saveFreeProducts: 'saveFreeProducts',
    setActivePlan: 'setActivePlan',
    setFeatures: 'setFeatures',
    setHost: 'setHost',
    setLocations: 'setLocations',
    setStore: 'setStore',
    setRemainingTrial: 'setRemainingTrial',
    setFeedback: 'setFeedback',
    setOpenWidget: 'setOpenWidget',
    setRedirected: 'setRedirected',
}

export default actionTypes